import React from 'react';
import { eventInfo } from '../../data/eventInfo';
import { Card, CardHeader, CardBody } from '../UI/Card';
import styles from './EventInfo.module.css';

/**
 * EventInfo component displays general event information including:
 * - Event name, date, and location
 * - Event description
 * - Rules and guidelines
 * - Contact information
 * 
 * Uses small cards with responsive grid layout (stack on mobile, 2 columns on tablet+)
 * Applies cyan accent for contact links and fire accent for rule indicators
 */
export const EventInfo: React.FC = () => {
  const { name, date, location, description, rules } = eventInfo;

  return (
    <Card className={styles.eventInfo}>
      <CardBody>
        {/* Event Header */}
        <div className={styles.header}>
          <h1 className={styles.title}>{name}</h1>
          <p className={styles.subtitle}>
            {date} • {location}
          </p>
        </div>

        {/* Event Description */}
        {description && (
          <p className={styles.description}>{description}</p>
        )}

        {/* Information Grid */}
        <div className={styles.infoGrid}>
          {/* Rules Section */}
          {rules && rules.length > 0 && (
            <Card className={styles.infoCard}>
              <CardHeader>
                <h3 className={styles.infoCardTitle}>Rules & Guidelines</h3>
              </CardHeader>
              <ul className={styles.rulesList}>
                {rules.map((rule, index) => (
                  <li key={index} className={styles.ruleItem}>
                    {rule}
                  </li>
                ))}
              </ul>
            </Card>
          )}


        </div>
      </CardBody>
    </Card>
  );
};
